define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi/def/Rule",
	"csi/html",
	"csi/reflection",
	"csi/table/Widget",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, _, Rule, html, reflection, Widget, xml, Query) {

	var _rule = lang.mixin(new Rule(), {
		m_class: html.CSS_HIDE,

		passes: function(node, cache, ctx) {
			var master = ctx.getNodeContext();
			var rev = master && ctx.cache.getNode(master.CurrentRevision);
			return !rev || (rev.State != reflection.REVISION_APPROVED);
		}
	});

	function _isCurrentRevision(/*Heading*/h) {
		return h && h.m_path && (h.m_path.indexOf(reflection.PATH_CURRENT_REVISION) == 0);
	}

	return declare(Widget, {
		addCurrentRevisionRule: function(/*Heading*/h) {
			// summary: add rule to hide attributes from CurrentRevision if not approved
			if (_isCurrentRevision(h) && (_.indexOf(h.m_rules, _rule) < 0)) {
				h.m_rules = h.m_rules || [];
				h.m_rules.push(_rule);
			}
		},

		getHeadingSpec: function(/*String*/key) {
			// summary: return spec given data point key
			var spec = this.inherited(arguments);
			this._addSpecRevisionBehavior(spec);
			return spec;
		},

		_addSpecRevisionBehavior: function(/*Spec*/spec) {
			// summary: apply heading rule and extra filter to spec to support approved revision behavior
			var h = spec && spec.heading;

			if (_isCurrentRevision(h)) {
				this.addCurrentRevisionRule(h);
				spec.extraFilter = spec.extraFilter || new Query().Attr(reflection.ATTR_STATE, xml.OP_EQUALS, reflection.REVISION_APPROVED, reflection.PATH_CURRENT_REVISION);
			}
		},

		_resolveColumns() {
			// summary: TA20299 iterate through view specs and add rule to hide attributes from the current revision if it is not approved
			// FIX: hiding values like this is not a great idea because the value is really there, so filtering and sorting will pick it up;
			// it is better to either show it, or change the model so that the value really does not exist in such a case (need ApprovedRevision rather than CurrentRevision)
			this.inherited(arguments);

			this.columnData.traverse(true, function(c, sc) {
				this._addSpecRevisionBehavior(sc || c);
			}, this);
		}
	});
});